import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({
  baseURL: `${API}/admin`,
  withCredentials: true,
});

const clean = (params) => {
  if (!params) return {};
  return Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== '')
  );
};

export const adminAPI = {
  getStats: () => client.get('/stats').then((r) => r.data),

  // Orders
  listOrders: (params) => client.get('/orders', { params: clean(params) }).then((r) => r.data),
  getOrder: (id) => client.get(`/orders/${id}`).then((r) => r.data),
  updateOrderStatus: (id, payload) => client.patch(`/orders/${id}/status`, payload).then((r) => r.data),
  exportOrdersCSVUrl: (params) => {
    const qs = new URLSearchParams(clean(params)).toString();
    return `${API}/admin/orders/export.csv${qs ? '?' + qs : ''}`;
  },

  // Products / inventory
  listProducts: (params) => client.get('/products', { params: clean(params) }).then((r) => r.data),
  updateProduct: (id, payload) => client.patch(`/products/${id}`, payload).then((r) => r.data),

  // Shipping rates
  listShippingRates: () => client.get('/shipping-rates').then((r) => r.data),
  createShippingRate: (payload) => client.post('/shipping-rates', payload).then((r) => r.data),
  updateShippingRate: (id, payload) => client.patch(`/shipping-rates/${id}`, payload).then((r) => r.data),
  deleteShippingRate: (id) => client.delete(`/shipping-rates/${id}`).then((r) => r.data),
  // Coupons
  listCoupons: () => client.get('/coupons/').then((r) => r.data),
  couponStats: () => client.get('/coupons/stats').then((r) => r.data),
  createCoupon: (payload) => client.post('/coupons/', payload).then((r) => r.data),
  updateCoupon: (id, payload) => client.patch(`/coupons/${id}`, payload).then((r) => r.data),
  deleteCoupon: (id) => client.delete(`/coupons/${id}`).then((r) => r.data),

  // Payments reconciliation
  listPayments: (params) => client.get('/payments', { params: clean(params) }).then((r) => r.data),
  refreshPayment: (reference) => client.post(`/payments/${reference}/refresh`).then((r) => r.data),

  // Reviews moderation
  listReviews: (params) => client.get('/reviews/', { params: clean(params) }).then((r) => r.data),
  moderateReview: (id, action) => client.patch(`/reviews/${id}`, { action }).then((r) => r.data),
  deleteReview: (id) => client.delete(`/reviews/${id}`).then((r) => r.data),

  // Abandoned carts
  listAbandonedCarts: () => client.get('/abandoned-carts/').then((r) => r.data),
  forceSweepCarts: () => client.post('/abandoned-carts/sweep').then((r) => r.data),
};

export const publicCouponsAPI = {
  validate: (code, subtotal) =>
    axios
      .post(`${API}/coupons/validate`, { code, subtotal }, { withCredentials: true })
      .then((r) => r.data),
};


export default adminAPI;
